export function revealStep(lag) {
  if (lag <= 0) return 0
  if (lag > 48) return 4
  if (lag > 16) return 3
  if (lag > 4) return 2
  return 1
}
